export default __webpack_public_path__ + "19b1c67.png";